module.exports = __webpack_public_path__ + "img/Boxje_2.e9bceca2.png";